export default {
   reports: {
      getTableInfo: [],
      tableLabels: [],
      tableData: [],
      totalClients: 0,
      totalComments: 0,
      totalSignatures: 0,
      totalSignaturesByMonth: [],
      qtySignaturesByMonth: [],
      loadingInformation: false
   }
};
